import gql from 'graphql-tag';

export const createPageViewMutation = gql`
  mutation  createPageView($pageViewInput: PageViewInputDto!) {
    createPageView(pageViewInput: $pageViewInput)
}`;